import React from 'react';

import type { TUseBridgePlan } from './actions';

export type BridgePlanContextType = TUseBridgePlan;
export const BridgePlanContext = React.createContext<BridgePlanContextType>({} as TUseBridgePlan);

export const useBridgePlanContext = () => React.useContext(BridgePlanContext);
